var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BlockQuote bg--blue-charcoal"},[_c('div',{staticClass:"BlockQuote__icon"},[_c('BaseIcon',{attrs:{"icon":"quote-symbol","color":"white"}})],1),_vm._v(" "),_c('blockquote',[_vm._v("\n        "+_vm._s(_vm.quote)+"\n    ")]),_vm._v(" "),(_vm.cite)?_c('cite',[_vm._v("\n        "+_vm._s(_vm.cite)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }